<template>
    <div>
    <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
            <p class="modal-card-title">
                {{
                    $store.state.articles.props.id === 0 ? 'New Article' : 'Edit Article'
                }}               
            </p>
        </header>
            
        <section class="modal-card-body">
        
         <div class="row">

        <div class="row">
            <div class="col-45">
                <b-field custom-class="label" :label="'Article Name'">
                    <b-input custom-class="binput" v-model.trim="$store.state.articles.props.article_title">

                    </b-input>
                </b-field>     

            </div>
            <div class="col-10">
                &nbsp;
            </div>
            <div class="col-45">
                <b-field custom-class="label" :label="'Written By'">
                    <b-input custom-class="binput" v-model.trim="$store.state.articles.props.wrrite_by_name">

                    </b-input>
                </b-field>     
            </div>
            
        </div>
        <div class="row">
            <div class="col-45">
                <!--<b-field custom-class="label" :label="$t('message.type')+'*'">
                    <b-select 
                        class="binput" 
                        expanded 
                        v-model="$store.state.singleEntries.props.transaction_type">
                        
                        <option :value="1">
                            {{$t('message.income')}}
                        </option>
                        <option :value="2">
                            {{$t('message.expense')}}
                        </option>
                        
                    </b-select>
                </b-field>    -->

                <b-field custom-class="label" 
                    :label="'Profile Link'">
                   
                   <b-input custom-class="binput" v-model.trim="$store.state.articles.props.wrrite_by_profile_link">

                    </b-input>
                </b-field>    
                
            </div>
            
            <div class="col-10">
                &nbsp;
            </div>
            <div class="col-45">
                   
            </div>
        </div>
        <div class="row">
            <b-field custom-class="label" :label="'Article Content'">
                     
                <textarea class="binput" rows="2" v-model.trim="$store.state.articles.props.article_content" cols="200" style="width:100% !important;height:350px !important;"></textarea>     
                
            </b-field>    
        </div>
         </div>
        <div style="text-align: center">
            <a @click="submit" class="button is-primary">Submit</a>
        </div>
        </section>
    </div>

    

    </div>
</template>

<script>
    export default {
        data() {
            return {
                
            }
        },
        computed: {
            
        },
        methods: {
            submit() {

                if(this.$store.state.articles.props.article_title.length === 0) {
                    this.$store.commit('setAlertBox', {title: 'Error', message: 'Fill all fields'})
                    return
                }

                if(this.$store.state.articles.props.wrrite_by_name.length === 0) {
                    this.$store.commit('setAlertBox', {title: 'Error', message: 'Fill all fields'})
                    return
                }

                if(this.$store.state.articles.props.article_content.length === 0) {
                    this.$store.commit('setAlertBox', {title: 'Error', message: 'Fill all fields'})
                    return
                }

                if(this.$store.state.articles.props.wrrite_by_profile_link.length === 0) {
                    this.$store.commit('setAlertBox', {title: 'Error', message: 'Fill all fields'})
                    return
                }

                setTimeout(() => {
                    this.$store.dispatch('postArticleProfile', this.$store.state.articles.props)    
                }, 100);
                
                this.$emit('closeModule')
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/Dashboard/Form.vue